import type { ReactNode } from "react";

import { useCan } from "@/lib/auth/useCan";

/** Conditionally render children based on a permission. Defaults to rendering
 *  nothing when the user lacks the permission; override with `fallback`. */
export function RequirePermission({
  perm,
  fallback = null,
  children,
}: {
  perm: string;
  fallback?: ReactNode;
  children: ReactNode;
}) {
  return useCan(perm) ? <>{children}</> : <>{fallback}</>;
}
